import React from "react";
import ResourceOptions from "../../components/ResouceOptions/ResourceOptions";

const Resources = () => {
    return (
        <div className="resources-container">
            <div>
                <ResourceOptions />
            </div>

        </div>
    );
};

export default Resources;